import { render, staticRenderFns } from "./GeneratorLinkPay.vue?vue&type=template&id=12b6ac6b&scoped=true&"
import script from "./GeneratorLinkPay.vue?vue&type=script&lang=js&"
export * from "./GeneratorLinkPay.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorLinkPay.vue?vue&type=style&index=0&id=12b6ac6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6ac6b",
  null
  
)

export default component.exports